import { Directive } from "@angular/core";
import { NG_VALIDATORS, Validator, UntypedFormControl } from "@angular/forms";

@Directive({
    selector: "[requireFile]",
    providers: [
        { provide: NG_VALIDATORS, useExisting: FileValidator, multi: true },
    ]
})

// https://stackoverflow.com/questions/41889384/angular2-validation-for-input-type-file-wont-trigger-when-changing-the-fi/41938495#41938495
// https://plnkr.co/edit/aj6VjL5CbZuwHq1MoA8I?p=preview

export class FileValidator implements Validator {
    static validate(c: UntypedFormControl): { [key: string]: any } {
        return c.value == null || c.value.length == 0 ? { "required": true } : null;
    }

    validate(c: UntypedFormControl): { [key: string]: any } {
        return FileValidator.validate(c);
    }
}
